import { render } from "./CostStandards.vue?vue&type=template&id=7f5368f0&scoped=true&ts=true"
import script from "./CostStandards.vue?vue&type=script&lang=ts"
export * from "./CostStandards.vue?vue&type=script&lang=ts"

import "./CostStandards.vue?vue&type=style&index=0&id=7f5368f0&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5368f0"]])

export default __exports__